export function formatDate(date: Date) {
  const day = String(date.getDate()).padStart(2, "0");
  const month = date
    .toLocaleString("default", { month: "short" })
    .toLowerCase();
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}
export function convertToSlug(str: string) {
  return str
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-zA-Z0-9-]/g, "")
    .replace(/-+/g, "-");
}
export const downloadCSV = function (data: string, fileName: string) {
  const blob = new Blob([data], { type: "text/csv" });
  const today = new Date();
  const date = formatDate(today);
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.setAttribute("href", url);
  const slug = convertToSlug(fileName);
  a.setAttribute("download", `${slug ? slug : "all-projects"}_${date}.csv`);
  a.click();
  a.remove();
};
